export default __webpack_public_path__ + "static/media/plus.4dfb65b3.svg";